// Cari seçici seçenekleri: ünvan + VKN/TCKN/telefon ile arama, KDV'li / KDV'siz rozeti
export const kdvBadge = (c) => (c?.vat_exempt ? "KDV'siz" : "KDV'li");
export const kdvBadgeCls = (c) => (c?.vat_exempt ? "bg-amber-100 text-amber-800 border-amber-300" : "bg-emerald-100 text-emerald-800 border-emerald-300");

export const contactOption = (c, extra = {}) => ({
  value: c.title,
  label: c.title,
  keywords: [c.tax_no, c.phone, c.email].filter(Boolean).join(" "),
  hint: c.tax_no ? `VKN/TCKN ${c.tax_no}` : "",
  badge: kdvBadge(c),
  badgeCls: kdvBadgeCls(c),
  vat_exempt: !!c.vat_exempt,
  ...extra,
});

export const contactOptions = (contacts = [], mapExtra) => contacts.map((c) => contactOption(c, mapExtra ? mapExtra(c) : {}));

// Genel müşteri (PERAKENDE MÜŞTERİ vb.): yalnız bu kelimelerden oluşan ünvan — adına fatura KESİLMEZ (sunucu ile aynı kural)
const GENERIC_WORDS = new Set(["PERAKENDE", "PARAKENDE", "MÜŞTERİ", "MÜŞTERİSİ", "MÜŞTERİLER", "SATIŞ", "NİHAİ", "TÜKETİCİ", "GENEL", "NAKİT", "CARİ", "KASA"]);
export const isGenericContact = (title) => {
  const toks = String(title || "").toLocaleUpperCase("tr").replace(/[^\p{L}\p{N}\s]/gu, " ").split(/\s+/).filter(Boolean);
  return toks.length > 0 && toks.every((t) => GENERIC_WORDS.has(t));
};
